import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/layout/Default.js";
import CarouselExample1 from './CarouselExample1.js';
import CarouselExample2 from './CarouselExample2.js';
import CarouselExample3 from './CarouselExample3.js';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Usage`}</h2>
    <p>{`For use this components don’t forget to add import `}<inlineCode parentName="p">{`legion-ui`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Carousel } from 'legion-ui';
`}</code></pre>
    <div className="divi" />
    <h2><strong parentName="h2">{`Variant`}</strong></h2>
    <p>{`Legion have three variant of Carousel. For using carousel you can create style first`}</p>
    <h3><strong parentName="h3">{`Basic Carousel`}</strong></h3>
    <div style={{
      "padding": "2rem",
      "backgroundColor": "#F6F7FC",
      "textAlign": "center"
    }}>
  <CarouselExample3 mdxType="CarouselExample3" />
    </div>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const data = [
  {
    imageURL: 'https://legion-dev.vercel.app/images/apple.png',
    alt: '1',
  },
  {
    imageURL: 'https://legion-dev.vercel.app/images/apple.png',
    alt: '2',
  },
  {
    imageURL: 'https://legion-dev.vercel.app/images/apple.png',
    alt: '3',
  },
];

<div className={styles.wrapper}>
  <Card sx={{ borderRadius: 0 }}>
    <Carousel autoplay data={data} ratio={7 / 3} showControl />
  </Card>
</div>
`}</code></pre>
    <h3><strong parentName="h3">{`Carousel with Indicator`}</strong></h3>
    <div style={{
      "padding": "2rem",
      "backgroundColor": "#F6F7FC",
      "textAlign": "center"
    }}>
  <CarouselExample2 mdxType="CarouselExample2" />
    </div>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const data = [
  {
    imageURL: 'https://legion-dev.vercel.app/images/apple.png',
    alt: '1',
  },
  {
    imageURL: 'https://legion-dev.vercel.app/images/apple.png',
    alt: '2',
  },
  {
    imageURL: 'https://legion-dev.vercel.app/images/apple.png',
    alt: '3',
  },
];

<div className={styles.wrapper}>
  <Card sx={{ borderRadius: 0 }}>
    <Carousel data={data} ratio={7 / 3} showIndicator showControl />
  </Card>
</div>
`}</code></pre>
    <h3><strong parentName="h3">{`Carousel with Subtitle`}</strong></h3>
    <div style={{
      "padding": "2rem",
      "backgroundColor": "#F6F7FC",
      "textAlign": "center"
    }}>
  <CarouselExample1 mdxType="CarouselExample1" />
    </div>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const data = [
  {
    imageURL: 'https://legion-dev.vercel.app/images/apple.png',
    alt: '1',
    title: 'Sub title',
    desc: 'Mauris, turpis augue mauris tellus massa, lacus. Id quam adipiscing tincidunt at feugiat arcu in',
  },
  {
    imageURL: 'https://legion-dev.vercel.app/images/apple.png',
    alt: '2',
    title: 'Sub title',
    desc: 'Mauris, turpis augue mauris tellus massa, lacus. Id quam adipiscing tincidunt at feugiat arcu in',
  },
  {
    imageURL: 'https://legion-dev.vercel.app/images/apple.png',
    alt: '3',
    title: 'Sub title',
    desc: 'Mauris, turpis augue mauris tellus massa, lacus. Id quam adipiscing tincidunt at feugiat arcu in',
  },
];

<div className={styles.wrapper}>
  <Card sx={{ borderRadius: 0 }}>
    <Carousel showIndicator showControl data={data} titleSize="14px" descSize="7px" ratio={7 / 3} />
  </Card>
</div>
`}</code></pre>
    <div className="divi" />
    <h3><strong parentName="h3">{`Example style`}</strong></h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`
.wrapper {
  width: 500px;
}

`}</code></pre>
    <div className="divi" />
    <h2>{`Props`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`propType`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`desc`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`autoplay`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`boolean`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`false`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets autoplay to slider`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`data`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Array<CarouselData`}{`>`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`yes`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets data of carousel`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`descSize`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets description font size (can use px or rem)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`showControl`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`boolean`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Status that makes navigation or control appear or not`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`showIndicator`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`boolean`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`false`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Status that makes indicator appear or not`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`ratio`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`yes`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`false`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets image aspec ratio, same argument taken from Image component`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`titleSize`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`yes`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets title font size (can use px or rem)`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      